import apiService from './api-service'

const movementsService = {}

/**
 * Retrieve a colabs by it's id
 * @param  array params (optional)
 * @return colabs
 */
movementsService.list = function (params) {
  return apiService.get(`/movements`, { params }).then(res => res.data)
}

/**
 * Retrieve a colabs minified by it's id
 * @param  array params (optional)
 * @return colabs
 */
movementsService.listColabs = function (params) {
  return apiService.get(`/colaborators-select`, { params }).then(res => res.data)
}

/**
 * Retrieve a colabs by it's id
 * @param  int id
 * @param  array params (optional)
 * @return colabs
 */
movementsService.getById = function (id) {
  return apiService.get(`/movements/${id}`, { id }).then(res => res.data).catch(error => error)
}

/**
 * Update a colabs by it's id
 * @param  int id
 * @param  array params (optional)
 * @return colabs
 */
movementsService.updateById = function (id, body) {
  body['_method'] = 'PUT'
  return apiService.put(`/movements/${id}`, body).then(res => res.data)
}

/**
 * Create a promoters by it's id
 * @param  object body
 * @return promoters
 */
movementsService.post = function (body) {
  return apiService.post(`/movements`, body).then(res => res.data)
}

/**
 * Retrieve all accounts codes
 * @param  object params
 * @return status' list
 */
movementsService.getAccountsList = function (id) {
  return apiService.get(`/movements/${id}/accounts`, { id }).then(res => res.data)
}

export default movementsService



// WEBPACK FOOTER //
// ./src/services/movements.js